import {
  MdPeople,
  MdCreate,
  MdMessage,
  MdPsychology,
  MdAutoGraph,
  MdSmartToy,
  MdPhoneAndroid,
  MdBarChart,
  MdExtension
} from "react-icons/md";

// Intros Imports
import AIIntros from "views/admin/intros";
import IntroStats from "views/admin/intros/dashboard";
import IntroductionWorkflows from "views/admin/intros/workflows";

// Mobile Imports
import DashboardsDefault from "views/admin/mobile/dashboard";
import Messages from "views/admin/mobile/messaging/messages";
import LatteAIConversations from "views/admin/mobile/messaging/latteAI";
import Announcements from "views/admin/mobile/messaging/announcements";
import MentorshipSettings from "views/admin/mobile/mentorship/settings";
import MentorAssignments from "views/admin/mobile/mentorship/assignments";
import MentorshipConnections from "views/admin/mobile/mentorship/relationships";
import ActiveAssignments from "views/admin/mobile/mentorship/active";
import ContentCreation from "views/admin/mobile/content";

// Integrations Import
import Integrations from "views/admin/integrations";

// Users Imports (shared)
import UserNew from "views/admin/users/newUser";
import AddUser from "views/admin/users/addUser";
import AddUserFile from "views/admin/users/addUserFile";
import UsersOverview from "views/admin/users/overview";
import UsersReports from "views/admin/users/reports";
import UserActivity from "views/admin/users/activity";
import UserEmails from "views/admin/users/emails";

// Auth Imports
import SignInDefault from "views/auth/signIn/SignInDefault";

const routes = [
  // {
  // 	name: 'Main Dashboard',
  // 	layout: '/admin',
  // 	path: 'default',
  // 	icon: <DashIcon />,
  // 	component: <NftCollection />
  // },
  // {
  // 	name: 'NFT Marketplace',
  // 	layout: '/admin',
  // 	path: 'nft-marketplace',
  // 	icon: <MarketIcon />,
  // 	component: <NftProfile />,
  // 	secondary: true
  // },
  // {
  // 	name: 'Data Tables',
  // 	layout: '/admin',
  // 	icon: <TablesIcon />,
  // 	path: 'data-tables',
  // 	component: <Alerts />
  // },
  // {
  // 	name: 'Profile',
  // 	layout: '/admin',
  // 	path: 'profile',
  // 	icon: <ProfileIcon />,
  // 	component: <ProfileOverview />
  // },
  // {
  // 	name: 'Sign In',
  // 	layout: '/auth',
  // 	path: 'sign-in',
  // 	icon: <SignInIcon />,
  // 	component: <ForgotPasswordCentered />
  // },
  // {
  // 	name: 'Default',
  // 	layout: '/auth',
  // 	path: '/sign-in/default',
  // 	component: <LockCentered />
  // },
  // --- Dashboards ---
  {
    name: "Mobile Dashboard",
    layout: "/admin", 
    path: "/dashboards/default",
    icon: <MdPhoneAndroid className="text-inherit h-5 w-5" />,
    component: <DashboardsDefault />,
  },
  // --- AI Intro Routes ---
  {
    name: "Intros Dashboard",
    layout: "/admin", 
    path: "/intros/dashboard",
    icon: <MdBarChart className="text-inherit h-5 w-5" />,
    component: <IntroStats />,
  },
  {
    name: "Latte AI Intros",
    layout: "/admin",
    path: "/intros/engine",
    icon: <MdSmartToy className="text-inherit h-5 w-5" />,
    component: <AIIntros />,
  },
  {
    name: "Workflows",
    layout: "/admin",
    path: "/intros/workflows",
    icon: <MdCreate className="text-inherit h-5 w-5" />,
    component: <IntroductionWorkflows />,
  },
  // --- Integrations ---
  {
    name: "Integrations",
    layout: "/admin",
    path: "/integrations",
    icon: <MdExtension className="text-inherit h-5 w-5" />,
    component: <Integrations />,
  },
  // --- NFTs ---
  // {
  //   name: "NFTs",
  //   path: "/nfts",
  //   icon: <MdOutlineShoppingCart className="text-inherit h-5 w-5" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: "Marketplace",
  //       layout: "/admin",
  //       path: "/nfts/marketplace",
  //       component: <NFTMarketplace />,
  //       secondary: true,
  //     },
  //     {
  //       name: "Collection",
  //       layout: "/admin",
  //       path: "/nfts/collection",
  //       component: <NFTCollection />,
  //       secondary: true,
  //     },
  //     {
  //       name: "NFT Page",
  //       layout: "/admin",
  //       path: "/nfts/page",
  //       component: <NFTPage />,
  //       secondary: true,
  //     },
  //     {
  //       name: "Profile",
  //       layout: "/admin",
  //       path: "/nfts/profile",
  //       component: <NFTProfile />,
  //       secondary: true,
  //     },
  //   ],
  // },
  // --- User Management ---
  {
    name: "User Management",
    path: "/main",
    icon: <MdPeople className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      // {
      //   name: "Account",
      //   path: "/main/account",
      //   collapse: true,
      //   items: [
      //     {
      //       name: "Billing",
      //       layout: "/admin",
      //       path: "/main/account/billing",
      //       exact: false,
      //       component: <AccountBilling />,
      //     },
      //     {
      //       name: "Application",
      //       layout: "/admin",
      //       path: "/main/account/application",
      //       exact: false,
      //       component: <AccountApplications />,
      //     },
      //     {
      //       name: "Invoice",
      //       layout: "/admin",
      //       path: "/main/account/invoice",
      //       exact: false,
      //       component: <AccountInvoice />,
      //     },
      //     {
      //       name: "Settings",
      //       layout: "/admin",
      //       path: "/main/account/settings",
      //       exact: false,
      //       component: <AccountSettings />,
      //     },
      //     {
      //       name: "All Courses",
      //       layout: "/admin",
      //       path: "/main/account/all-courses",
      //       exact: false,
      //       component: <AccountAllCourses />,
      //     },
      //     {
      //       name: "Course Page",
      //       layout: "/admin",
      //       path: "/main/account/course-page",
      //       exact: false,
      //       component: <AccountCoursePage />,
      //     },
      //   ],
      // },
      // {
      //   name: "Ecommerce",
      //   path: "/ecommerce",
      //   collapse: true,
      //   items: [
      //     {
      //       name: "New Product",
      //       layout: "/admin",
      //       path: "/main/ecommerce/new-prodcut",
      //       exact: false,
      //       component: <EcommerceNewProduct />,
      //     },
      //     {
      //       name: "Product Settings",
      //       layout: "/admin",
      //       path: "/main/ecommerce/settings",
      //       exact: false,
      //       component: <EcommerceProductSettings />,
      //     },
      //     {
      //       name: "Product Page",
      //       layout: "/admin",
      //       path: "/main/ecommerce/page-example",
      //       exact: false,
      //       component: <EcommerceProductPage />,
      //     },
      //     {
      //       name: "Order List",
      //       layout: "/admin",
      //       path: "/main/ecommerce/order-list",
      //       exact: false,
      //       component: <EcommerceOrderList />,
      //     },
      //     {
      //       name: "Order Details",
      //       layout: "/admin",
      //       path: "/main/ecommerce/order-details",
      //       exact: false,
      //       component: <EcommerceOrderDetails />,
      //     },
      //     {
      //       name: "Referrals",
      //       layout: "/admin",
      //       path: "/main/ecommerce/referrals",
      //       exact: false,
      //       component: <EcommerceReferrals />,
      //     },
      //   ],
      // },
      {
        name: "Add Users via File",
        layout: "/admin",
        path: "/main/users/file-upload",
        exact: true,
        component: <AddUserFile />,
      },
      {
        name: "Users Overview",
        layout: "/admin",
        path: "/main/users/users-overview",
        exact: false,
        component: <UsersOverview />,
      },
      {
        name: "User Emails",
        layout: "/admin",
        path: "/main/users/emails",
        exact: false,
        component: <UserEmails />,
      },
      {
        name: "Invite Users",
        layout: "/admin",
        path: "/main/users/new-user",
        exact: false,
        component: <UserNew />,
        comingSoon: true,
      },
      {
        name: "Add User via Search",
        layout: "/admin",
        path: "/main/users/search",
        exact: true,
        component: <AddUser />,
        comingSoon: true,
      },
      {
        name: "Users Reports",
        layout: "/admin",
        path: "/main/users/users-reports",
        exact: false,
        component: <UsersReports />,
        comingSoon: true,
      },
      {
        name: "User Activity",
        layout: "/admin",
        path: "/main/users/activity",
        exact: false,
        component: <UserActivity />,
        comingSoon: true,
      },
      // {
      //   name: "Applications",
      //   path: "/main/applications",
      //   collapse: true,
      //   items: [
      //     {
      //       name: "Kanban",
      //       layout: "/admin",
      //       path: "/main/applications/kanban",
      //       exact: false,
      //       component: <ApplicationsKanban />,
      //     },
      //     {
      //       name: "Data Tables",
      //       layout: "/admin",
      //       path: "/main/applications/data-tables",
      //       exact: false,
      //       component: <ApplicationsDataTables />,
      //     },
      //     {
      //       name: "Calendar",
      //       layout: "/admin",
      //       path: "/main/applications/calendar",
      //       exact: false,
      //       component: <ApplicationsCalendar />,
      //     },
      //   ],
      // },
      // {
      //   name: "Profile",
      //   path: "/main/profile",
      //   collapse: true,
      //   items: [
      //     {
      //       name: "Profile Overview",
      //       layout: "/admin",
      //       path: "/main/profile/overview",
      //       exact: false,
      //       component: <ProfileOverview />,
      //     },
      //     {
      //       name: "Profile Settings",
      //       layout: "/admin",
      //       path: "/main/profile/settings",
      //       exact: false,
      //       component: <ProfileSettings />,
      //     },
      //     {
      //       name: "News Feed",
      //       layout: "/admin",
      //       path: "/main/profile/newsfeed",
      //       exact: false,
      //       component: <ProfileNewsfeed />,
      //     },
      //   ],
      // },
      // {
      //   name: "Others",
      //   path: "/main/others",
      //   collapse: true,
      //   items: [
      //     {
      //       name: "Notifications",
      //       layout: "/admin",
      //       path: "/main/others/notifications",
      //       exact: false,
      //       component: <OthersNotifications />,
      //     },
      //     {
      //       name: "Pricing",
      //       layout: "/auth",
      //       path: "/main/others/pricing",
      //       exact: false,
      //       component: <OthersPricing />,
      //     },
      //     {
      //       name: "404",
      //       layout: "/admin",
      //       path: "/main/others/404",
      //       exact: false,
      //       component: <OthersError />,
      //     },
      //     {
      //       name: "Buttons",
      //       layout: "/admin",
      //       path: "/main/others/buttons",
      //       exact: false,
      //       component: <Buttons />,
      //     },
      //     {
      //       name: "Messages",
      //       layout: "/admin",
      //       path: "/main/others/messages",
      //       exact: false,
      //       component: <Messages />,
      //     },
      //   ],
      // },
    ],
  },
  // --- Create Connections ---
  {
    name: "Create Connections",
    path: "/matching",
    icon: <MdAutoGraph className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: "New Assignment",
        layout: "/admin",
        path: "/matching/assignments",
        component: <MentorAssignments />,
      },
      {
        name: "Active Assignments",
        layout: "/admin",
        path: "/matching/active",
        component: <ActiveAssignments />,
      },
    ],
  },
  // --- Mentorship Management ---
  {
    name: "Mentorship",
    path: "/mentorship",
    icon: <MdPsychology className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: "Configuration",
        layout: "/admin",
        path: "/mentorship/settings",
        component: <MentorshipSettings />,
      },
      {
        name: "Existing Connections",
        layout: "/admin",
        path: "/mentorship/connections",
        component: <MentorshipConnections />,
      },
    ],
  },
  // --- Content Creation ---
  {
    name: "Content Creation",
    layout: "/admin",
    path: "/content/creation",
    icon: <MdCreate className="text-inherit h-5 w-5" />,
    component: <ContentCreation />,
  },
  // --- Messaging Center ---
  {
    name: "Messaging Center",
    path: "/messaging",
    icon: <MdMessage className="text-inherit h-5 w-5" />,
    collapse: true,
    items: [
      {
        name: "My Messages",
        layout: "/admin",
        path: "/messaging/all",
        component: <Messages />,
      },
      {
        name: "Latte AI Assistant",
        layout: "/admin",
        path: "/messaging/latte-ai",
        component: <LatteAIConversations />,
      },
      {
        name: "Announcements",
        layout: "/admin",
        path: "/messaging/announcements",
        component: <Announcements />,
      },
    ],
  },
  // --- Auth Routes (hidden from navigation) ---
  {
    layout: "/auth",
    path: "/sign-in/default",
    component: <SignInDefault />,
  },
  // {
  // 	name: 'RTL Admin',
  // 	layout: '/rtl',
  // 	path: 'rtl-default',
  // 	// icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
  // 	component: () => <MainDashboard /> RTL
  // }
];
export default routes;
